export default __webpack_public_path__ + "static/media/2009-IMcover.18738911.jpg";